import { Box, Container, FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Modal, OutlinedInput, Select } from '@material-ui/core';
import { format, formatISO } from 'date-fns';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { BackButton, SubmitButton } from '../../../Components/Custom';
import Dashboard from '../../../Components/Dashboard';
import history from '../../../Services/history';
import { store } from '../../../store';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { ptBR } from 'date-fns/locale';
import stylePagesEmbalei from './style';
import { CategoryOutlined, DeleteForeverOutlined, LocalGroceryStoreOutlined, SettingsOutlined, EditOutlined } from '@material-ui/icons';
import { apiLabs } from '../../../Services/api';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function GoalsExpedition(props) {
  const [modal, setModal] = useState({
    id: 0,
    active: false
  })
  const [date, setDate] = useState(new Date())
  const [dateFiltered, setDateFiltered] = useState()

  const { location: { idPage } } = props
  const [auth, setAuth] = useState(null)

  const [goals, setGoals] = useState([])
  const [goal, setGoal] = useState({
    title: "",
    date: new Date(),
    expected_total_parts: 0,
    expected_total_price: 0,
    expected_total_orders: 0,
  })

  async function verifyAuth() {
    const { profile } = store.getState().user
    const res = await apiLabs.post('valid_key', { id: profile.id, menu_id: idPage })
    if (res.data.message === "User not authorized") {
      return setAuth('denied')
    }
    if (res.data.message === "User authorized") {
      return setAuth('authorized')
    }
    return history.push({ pathname: '/', state: { from: props.location } })
  }

  const isDate = (date) => {
    return new Date(date) !== "Data inválida!" && !isNaN(new Date(date));
  };

  function handleValue(value, key) {
    if (key === 'date') {
      if (!value || !isDate(value)) {
        setDate("Invalid Date");
        return;
      }

      const parsedDate = formatISO(new Date(value));
      setDate(parsedDate);

      setGoal({
        ...goal,
        date: parsedDate,
      });

      return;
    }
    setGoal({
      ...goal,
      [key]: value,
    });
  }

  async function envGoal(e) {
    try {
      e.preventDefault()
      const goalsExpeditionResponse = await apiLabs.post('meta-operacao', {
        ...goal
      })
      if (goalsExpeditionResponse.data) {
        toast.success(`Meta cadastrada com sucesso`, {
          autoClose: 5000
        })

        getGoals()
      }
    } catch (error) {
      toast.error('Falha ao cadastrar META. Entre em contato com a equipe SantoLabs^.', {
        autoClose: 5000
      })
    }
  }

  async function deleteGoal(e, id) {
    e.preventDefault()
    try {
      await apiLabs.delete(`meta-operacao/${id}`)
      toast.success(`Meta Deletada com Sucesso`, {
        autoClose: 5000
      })
      getGoals()
    } catch (error) {
      toast.error('Falha ao Deletar META. Entre em contato com a equipe SantoLabs^.', {
        autoClose: 5000
      })
    }
  }

  async function editGoal(e) {
    e.preventDefault()
    try {
      await apiLabs.put(`meta-operacao/${modal.id}`, goal)
      handleCloseModal()
      getGoals()
      toast.success(`Meta Atualizada com Sucesso`, {
        autoClose: 5000
      })
    } catch (error) {
      toast.error('Falha ao Atualizar META. Entre em contato com a equipe SantoLabs^.', {
        autoClose: 5000
      })
    }
  }

  function handleDateFiltered(value) {
    if (isDate(value)) {
      setDateFiltered(value)
    }
  }

  async function getGoals(dateForQuery) {
    try {
      const condition = {
        params: {
          dateStart: null
        }
      }
      if (isDate(dateForQuery)) {
        condition.params.dateStart = dateForQuery
      }
      const goalsExpeditionResponse = await apiLabs.get('meta-operacao', condition)
      setGoals(goalsExpeditionResponse.data.items)
      return
    } catch (error) {
      console.log(error)
    }
  }

  function resetFilters() {
    setDateFiltered(null)
    getGoals()
  }

  function handleOpenModal(id) {
    const goalObject = goals.find((result) => result.id === id)
    setGoal({
      // title: goalObject.title,
      // date: goalObject.date,
      expected_total_parts: goalObject.expected_total_parts,
      expected_total_price: goalObject.expected_total_price,
      expected_total_orders: goalObject.expected_total_orders,
    })
    setModal({
      id,
      active: true
    })
  }

  function handleCloseModal() {
    setModal({
      id: 0,
      active: false
    })

    setGoal({
      // title: "",
      // date: new Date(),
      expected_total_parts: 0,
      expected_total_price: 0,
      expected_total_orders: 0,
    })
  }

  useEffect(() => {
    verifyAuth()
    getGoals()
  }, [])

  useEffect(() => {
    getGoals(dateFiltered)
  }, [dateFiltered])

  const styles = stylePagesEmbalei()

  return (
    <>
      <Dashboard title="Metas Expedição">

        <Container maxWidth='md'>
          <Grid container spacing={2} alignItems='center'>
            <Grid item xs={12}>
              <h1 className={`${styles.titlePage}`}>Metas Expedição</h1>
            </Grid>

            <Grid item xs={12}>
              <form onSubmit={envGoal}>
                <Grid container spacing={2}>
                  <Grid item xs={4} className={styles.GridDate}>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={ptBR}
                      fullWidth
                    >
                      <KeyboardDatePicker
                        fullWidth
                        className={styles.dateRanking}
                        inputVariant="outlined"
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="date-ranking"
                        onChange={e => handleValue(e, "date")}
                        value={date}
                        label="Data da Meta"
                        invalidDateMessage="Data inválida"
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>

                  <Grid item xs={8}>
                    <FormControl fullWidth variant='outlined' >
                      <InputLabel>Tipo de Meta</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={goal.title}
                        label="Tipo de Meta"
                        onChange={e => handleValue(e.target.value, "title")}
                      >
                        <MenuItem value={"meta faturamento"}>Meta Faturamento</MenuItem>
                        <MenuItem value={"meta embalagem"}>Meta Embalagem</MenuItem>
                        <MenuItem value={"meta separação"}>Meta Separação</MenuItem>
                        <MenuItem value={"meta recebimento"}>Meta Recebimento</MenuItem>
                        <MenuItem value={"meta embarque"}>Meta Embarque</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    <FormControl fullWidth variant='outlined' >
                      <InputLabel>Meta de Itens</InputLabel>
                      <OutlinedInput
                        value={goal.expected_total_parts}
                        type='number'
                        onChange={e => handleValue(parseInt(e.target.value), "expected_total_parts")}
                        label="Meta de Itens"
                        startAdornment={
                          <InputAdornment position="start">
                            <IconButton
                              edge="start"
                            >
                              <CategoryOutlined />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    <FormControl fullWidth variant='outlined' >
                      <InputLabel>Meta de Pedidos</InputLabel>
                      <OutlinedInput
                        value={goal.expected_total_orders}
                        type='number'
                        onChange={e => handleValue(parseInt(e.target.value), "expected_total_orders")}
                        label="Meta de pedidos"
                        startAdornment={
                          <InputAdornment position="start">
                            <IconButton
                              edge="start"
                            >
                              <LocalGroceryStoreOutlined />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    <FormControl fullWidth variant='outlined' >
                      <InputLabel>Meta de Valor</InputLabel>
                      <OutlinedInput
                        startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                        value={goal.expected_total_price}
                        type='number'
                        onChange={e => handleValue(parseFloat(e.target.value), "expected_total_price")}
                        label="Meta de valor"
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <SubmitButton fullWidth type='submit'>Cadastrar Meta</SubmitButton>
                  </Grid>
                </Grid>
              </form>
            </Grid>

            <Grid item xs={12} md={6}>
              <h2 className={`${styles.titlePage}`}>Metas Cadastradas</h2>
            </Grid>

            <Grid item xs={6} md={2}>
              <BackButton onClick={() => resetFilters()}>LIMPAR FILTRO</BackButton>
            </Grid>

            <Grid item xs={6} md={4} className={styles.GridDate}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={ptBR}
                fullWidth
              >
                <KeyboardDatePicker
                  fullWidth
                  className={styles.dateRanking}
                  inputVariant="outlined"
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="date-ranking"
                  onChange={e => handleDateFiltered(e)}
                  value={dateFiltered ? dateFiltered : null}
                  label="Filtrar por Data"
                  invalidDateMessage="Data inválida"
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12}>
              <table
                className={styles.tableGoalExpedition}
                border={0}
                cellSpacing={0}
                data-js="export-table-excel"
              >
                <thead>
                  <tr>
                    <th align="left">Data</th>
                    <th align="left">Tipo de Meta</th>
                    <th align="left">Meta Itens</th>
                    <th align="left">Meta Pedidos</th>
                    <th align="left">Meta Valor R$</th>
                    <th align="center">
                      <SettingsOutlined />
                    </th>
                  </tr>
                </thead>

                <tbody data-js="table-body-excel">
                  {goals.map((result) => (
                    <tr key={result.id}>
                      <td>{format(new Date(result.date), 'dd/MM/yyyy')}</td>
                      <td>{result.title}</td>
                      <td>{result.expected_total_parts}</td>
                      <td>{result.expected_total_orders}</td>
                      <td>{result.expected_total_price}</td>
                      <td align="center">
                        <IconButton>
                          <EditOutlined onClick={() => handleOpenModal(result.id)} />
                        </IconButton>
                        <IconButton>
                          <DeleteForeverOutlined onClick={(e) => deleteGoal(e, result.id)} />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Grid>
          </Grid>
        </Container>

        <Modal
          open={modal.active}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle}>
            <form onSubmit={(e) => editGoal(e)}>
              <Grid container spacing={2}>
                {/* <Grid item xs={4} className={styles.GridDate}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={ptBR}
                    fullWidth
                  >
                    <KeyboardDatePicker
                      fullWidth
                      className={styles.dateRanking}
                      inputVariant="outlined"
                      disableToolbar
                      variant="inline"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="date-ranking"
                      onChange={e => handleValue(e, "date")}
                      value={date}
                      label="Data da Meta"
                      invalidDateMessage="Data inválida"
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid> */}

                {/* <Grid item xs={8}>
                  <FormControl fullWidth variant='outlined' >
                    <InputLabel>Tipo de Meta</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={goal.title}
                      label="Tipo de Meta"
                      onChange={e => handleValue(e.target.value, "title")}
                    >
                      <MenuItem value={"meta faturamento"}>Meta Faturamento</MenuItem>
                      <MenuItem value={"meta embalagem"}>Meta Embalagem</MenuItem>
                      <MenuItem value={"meta separação"}>Meta Separação</MenuItem>
                      <MenuItem value={"meta recebimento"}>Meta Recebimento</MenuItem>
                      <MenuItem value={"meta embarque"}>Meta Embarque</MenuItem>
                    </Select>
                  </FormControl>
                </Grid> */}

                <Grid item xs={4}>
                  <FormControl fullWidth variant='outlined' >
                    <InputLabel>Meta de Itens</InputLabel>
                    <OutlinedInput
                      value={goal.expected_total_parts}
                      type='number'
                      onChange={e => handleValue(parseInt(e.target.value), "expected_total_parts")}
                      label="Meta de Itens"
                      startAdornment={
                        <InputAdornment position="start">
                          <IconButton
                            edge="start"
                          >
                            <CategoryOutlined />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={4}>
                  <FormControl fullWidth variant='outlined' >
                    <InputLabel>Meta de Pedidos</InputLabel>
                    <OutlinedInput
                      value={goal.expected_total_orders}
                      type='number'
                      onChange={e => handleValue(parseInt(e.target.value), "expected_total_orders")}
                      label="Meta de pedidos"
                      startAdornment={
                        <InputAdornment position="start">
                          <IconButton
                            edge="start"
                          >
                            <LocalGroceryStoreOutlined />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={4}>
                  <FormControl fullWidth variant='outlined' >
                    <InputLabel>Meta de Valor</InputLabel>
                    <OutlinedInput
                      startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                      value={goal.expected_total_price}
                      type='number'
                      onChange={e => handleValue(parseFloat(e.target.value), "expected_total_price")}
                      label="Meta de valor"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <SubmitButton fullWidth type='submit'>Atualizar Meta</SubmitButton>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Modal>
      </Dashboard>
    </>
  )
}

export default GoalsExpedition;
